import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

/**
 * Syncs the language context with the current URL prefix.
 * Norwegian is the default locale. English only lives under /en/*.
 */
const LanguageRouteSync = () => {
  const { pathname } = useLocation();
  const { language, changeLanguage } = useLanguage();

  useEffect(() => {
    const isEnglish = pathname === "/en" || pathname.startsWith("/en/");
    if (isEnglish && language !== "en") changeLanguage("en");
    if (!isEnglish && language !== "no") changeLanguage("no");
  }, [pathname, language, changeLanguage]);

  return null;
};

export default LanguageRouteSync;
